import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output
} from '@angular/core';
import { IconSize } from '../../core-data-model/IconSize';
import { IconType } from '../../core-data-model/IconType';
import { Person } from '../../core-data-model/Person.model';
import { FeatureFlags, FeatureFlagsService } from '../../system-services';
import { Logger } from '../../system-services/Logger/Logger.service';
import { TranslationService } from '../../translations/Translation.service';
import { MyProfileTooltipService } from '../profile-tooltip/my-profile-tooltip.service';

@Component({
    selector: 'my-ba-profile',
    templateUrl: 'my-ba-profile.component.html',
    styleUrls: ['./my-ba-profile.less'],
    standalone: false
})
export class MyBaProfileComponent implements OnInit {
    @Input()
    showCoverView = false;

    @Input()
    person: Person;

    @Output()
    viewProfileClicked = new EventEmitter();

    IconSize = IconSize;
    IconType = IconType;

    insightsLoading = false;
    enableDownloadBA: boolean;

    constructor(
        public TR: TranslationService,
        private cd: ChangeDetectorRef,
        private logger: Logger,
        private myProfile: MyProfileTooltipService,
        private featureFlagService: FeatureFlagsService
    ) {}

    ngOnInit(): void {
        this.enableDownloadBA = this.featureFlagService.getByFlag(
            FeatureFlags.enableMyProfileDownloadBAReport
        );
    }

    getReferencePatternDesc(person: Person) {
        return this.TR.key(person?.referencePattern?.tooltipKey);
    }

    viewYourProfileClicked(event) {
        event.stopPropagation();
        this.viewProfileClicked.emit();
        this.showCoverView = false;
        this.logger.logInfo(
            'MyBAProfile - BA experience profile unlocked/viewed',
            {
                userId: this.person.id,
                email: this.person.email
            }
        );
    }

    updateInsightsLoading(loading: boolean) {
        this.insightsLoading = loading;
        // Added detection because 'loading' can change asynchronously during the angular life cycle
        // this causes an ExpressionChangedAfterItHasBeenChecked error.  This prevents that.
        this.cd.detectChanges();
    }

    downloadBAReport() {
        this.myProfile.downloadLoggedInUserBAReport();
    }
}
